export * from './test-with-script'
